import Wapper from './src/wapper'
export default Wapper


// WEBPACK FOOTER //
// ./src/components/wapper/index.js